// extracted by mini-css-extract-plugin
module.exports = {"otherNamesRelated":"OtherNamesRelated_otherNamesRelated__WhpoS","titleRegion":"OtherNamesRelated_titleRegion__1sQZr","title":"OtherNamesRelated_title__1PmaZ"};